import {
  StatusIndicator,
  StatusIndicatorProps,
} from '@amzn/awsui-components-react';
import { ReactElement } from 'react';
import { HomepageLinkCheckStatus } from '@amzn/awsdev-docs-virtual-smiley-typescript-client';

const statusMap: Record<HomepageLinkCheckStatus, StatusIndicatorProps> = {
  FullSuccess: {
    type: 'success',
    children: 'Fully Successful',
  },
  PartialSuccess: {
    type: 'warning',
    children: 'Partially Successful',
  },
  Failed: {
    type: 'error',
    children: 'Unsuccessful',
  },
  NA: {
    type: 'not-started',
    children: 'N/A',
  },
} as const;

export const HomepageLinkCheckStatusIndicator = ({
  status,
}: {
  status: HomepageLinkCheckStatus;
}): ReactElement => <StatusIndicator {...statusMap[status]} />;
